import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import { LINK_CONTRACTS } from '../../constants/link_constants'
import DateField from 'react-mobx-admin/components/common/field/date'
import DateInput from '../input/date'
import Filters from '../global_filters'
import ListView from 'bstrap-react-mobx-admin/view/list'
import OptionsField from 'react-mobx-admin/components/common/field/opts'
import SelectInput from '../input/select'
import TextField from 'react-mobx-admin/components/common/field/text'
import TextInput from 'bstrap-react-mobx-admin/input/text'

const ContractListView = ({ store }) => {
  //
  if (!store.hasRight(defaultConst.ENTNAMES.CONTRACTS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  const fields = [
    (attr, row) => (<TextField attr={attr} val={row[attr]} />),
    (attr, row) => {
      const DetailLink = ({ text }) => (
        <React.Fragment>
          <a href='javascript:void(0)' onClick={() => store.detailClicked(row)}>{text}</a>
          <a href={`/entity/${store.router.params.entityname}/${row.id}`}
            target="_blank" rel="noreferrer" title={store.__('Open link in new tab')} className="text-muted link-icon">
            <i className="glyphicon glyphicon-new-window" />
          </a>
        </React.Fragment>
      )
      return <TextField attr={attr} val={row[attr]} Component={DetailLink} />
    },
    (attr, row) => (
      <OptionsField
        attr={attr}
        val={row[attr]}
        options={store.options.get('ContractTypes')}
        labelattr='text'
        valueattr='value'/>
    ),
    (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.contract_end_date} />),
    (attr, row) => (<DateField attr={attr} val={row[attr]} valN={row.contract_date} />),
    (attr, row) => (<TextField attr={attr} val={row[attr]} />)
  ]

  const batchActions = () => {
    return (
      <button className={defaultConst.ACTION_BUTTON_CLASS2} type='button' onClick={store.batchDelete.bind(store)}>
        <span className='glyphicon glyphicon-remove' />&nbsp;{store.__('Delete')}</button>
    )
  }

  const filters = {
    id_like: {
      title: 'ID',
      component: (props) => (<TextInput {...props} />)
    },
    name_like: {
      title: 'Name',
      component: (props) => (<TextInput {...props} />)
    },
    contract_type: {
      title: 'contract type',
      component: (props) => (<SelectInput {...props} optionsrecord={store.options}
        labelattr='text' valueattr='value' optionsattr={'ContractTypes'} />)
    },
    contract_date__from: {
      title: 'contract date',
      component: (props) => (
        <div>
          <DateInput hideControlLabel asFilter {...props} />
          <DateInput hideControlLabel asFilter {...props} attr={props.attr + '__to'} />
        </div>
      )
    },
    contract_end_date__from: {
      title: 'contract end date',
      component: (props) => (
        <div>
          <DateInput hideControlLabel asFilter {...props} />
          <DateInput hideControlLabel asFilter {...props} attr={props.attr + '__to'} />
        </div>
      )
    }
  }

  return (<ListView
    store={store.cv}
    helper={store.helpFor(LINK_CONTRACTS)}
    fields={fields}
    filters={() => Filters(store, filters)}
    onAddClicked={store.addClicked.bind(store)}
    batchActions={batchActions} />)
}
export default observer(ContractListView)
